import styled from "styled-components";

export const StyledFooter = styled.footer`
    bottom: 0;
    display: flex;
    padding-top: 10px;
    padding-right: 3vw;
    padding-left: 3vw;
    justify-content: space-between;

    .footer-link {
        :hover {
            text-decoration: underline;
        }
    }

    .typo {
        margin: 5px;
        color: #00a5c0;
    }
`;